import React, { useState, useEffect } from "react";
import { Menu, X, ChevronRight, ExternalLink } from "lucide-react";
import "../css/header.css";
import logoutpl from "../img/utpl.png";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
/**
 * Componente Header UTPL - Versión con CSS Puro (Sin Tailwind)
 */

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const mainLinks = [
    { name: "Inicio", href: "/" },
    { name: "Carisma Idente", href: "/carisma-idente" },
    { name: "Oferta académica", href: "/oferta" },
    { name: "Matricúlate ahora", href: "/matriculas" },
    { name: "Contacto", href: "/contacto" },
    { name: "Soy UTPL", href: "https://soy.utpl.edu.ec/", external: true },
  ];

  const menuSections = [
    {
      title: "🎓 Oferta Académica",
      links: [
        { name: "Carreras a distancia y en línea", href: "/en-linea" },
        { name: "Carreras presencial", href: "/presencial" },
        { name: "Carreras tecnológicas", href: "/tecnologias" },
        { name: "Posgrados", href: "/posgrados" },
        { name: "UTPL Escuela de Negocios", href: "/escuela-negocios" },
        {
          name: "Formación permanente",
          href: "https://formacionpermanente.utpl.edu.ec",
          external: true,
        },
          {
          name: "Becas",
          href: "https://becas.utpl.edu.ec",
          external: true,
        },
      ],
    },
    {
      title: "👩‍🎓Estudiantes",
      links: [
        { name: "Cursos de Competencias Específicas", href: "/competencias" },
        { name: "Segunda Lengua", href: "/segunda-lengua" },
        { name: "Acompañamiento integral", href: "/acompanamiento-integral" },
      ],
    },

    {
      title: "🌍 Internacionalización",
      links: [
        { name: "Internacional", href: "/internacional" },
        { name: "Validación de título EE.UU.", href: "/validacion-titulo" },
      ],
    },

    {
      title: "🏛️ Universidad",
      links: [
        { name: "Acerca de nosotros", href: "/acercade" },
        { name: "Gobernanza", href: "/gobernanza" },
        { name: "Transparencia", href: "/transparencia" },
        { name: "Calidad", href: "/calidad" },
        { name: "Fernando Rielo", href: "/fernando-rielo" },
        { name: "Manual de imagen", href: "/imagen" },
        { name: "Gestión de procesos", href: "/gestion-procesos" },
      ],
    },
    {
      title: "⚖️ Servicios y Recursos",
      links: [
        { name: "Servicios Jurídicos", href: "/servicios-juridicos" },
        {
          name: "Consultorios Psicología ",
          href: "/consultorios-psicologia",
        },
        {
          name: "Biblioteca",
          href: "https://biblioteca.utpl.edu.ec",
          external: true,
        },
      ],
    },

    {
      title: "🔬 Investigación y Vinculación",
      links: [
        {
          name: "Investigación",
          href: "https://investigacion.utpl.edu.ec",
          external: true,
        },
        {
          name: "Vinculación",
          href: "https://vinculacion.utpl.edu.ec",
          external: true,
        },
        { name: "Parque Científico UTPL", href: "/parque-cientifico" },
        { name: "Informe GEM", href: "/informe-gem" },
        {
          name: "ILFAM",
          href: "https://ilfam.utpl.edu.ec",
          external: true,
        },
      ],
    },

    {
      title: "🤝 Comunidad y Cultura",
      links: [
        {
          name: "Misiones Universitarias",
          href: "https://utpl.edu.ec/misiones",
          external: true,
        },
        {
          name: "Eventos",
          href: "https://eventos.utpl.edu.ec",
          external: true,
        },
        {
          name: "Noticias",
          href: "https://noticias.utpl.edu.ec",
          external: true,
        },
        {
          name: "Trabaja con nosotros",
          href: "https://utpl.hiringroom.com/jobs",
          external: true,
        },
      ],
    },
  ];

  const quickLinks = [
    { name: "Correo", href: "https://utpl.edu.ec/mail", external: true },
    { name: "EVA", href: "https://utpl.edu.ec/eva", external: true },
    {
      name: "Sistema Académico",
      href: "/sistema-academico",
    },
    {
      name: "Servicios",
      href: "https://portales.utpl.edu.ec/servicios",
      external: true,
    },
    {
      name: "Directorio",
      href: "https://directorio.utpl.edu.ec/",
      external: true,
    },
  ];

  return (
    <>
      <header className="header-wrapper">
        <nav className="navbar">
          <div className="layout9">
            {/* Logo */}
            <div style={{ flexShrink: 0 }}>
              <a href="/">
                <img src={logoutpl} alt="Logo UTPL" className="logo-img" />
              </a>
            </div>

            {/* Enlaces Escritorio */}
            <div className="nav-desktop">
              <div className="quick-links-desktop">
                {quickLinks.slice(0, 3).map((link) => (
                  <>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        className="quick-link-top"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {link.name}
                      </a>
                    ) : (
                      <NavLink
                        to={link.href}
                        className="quick-link-top"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {link.name}
                      </NavLink>
                    )}
                  </>
                ))}
              </div>

              {mainLinks.map((link) => (
                <>
                  <NavLink to={link.href} className="nav-link">
                    {link.name} {link.external && <ExternalLink size={12} />}
                  </NavLink>
                </>
              ))}

              <button
                onClick={toggleMenu}
                className="hamburger-btn"
                aria-label="Menu"
              >
                <Menu size={30} />
              </button>
            </div>

            {/* Botón Móvil */}
            <div className="mobile-btn-container">
              <button onClick={toggleMenu} className="hamburger-btn">
                {isMenuOpen ? <X size={40} /> : <Menu size={30} />}
              </button>
            </div>
          </div>
        </nav>

        {/* Menú Lateral */}
        {isMenuOpen && (
          <div
            className="menu-overlay"
            style={{ opacity: isMenuOpen ? 1 : 0 }}
            onClick={toggleMenu}
          />
        )}

        <aside className={`menu-aside ${isMenuOpen ? "open" : ""}`}>
          <div className="menu-header">
            <button onClick={toggleMenu} className="close-btn">
              <X size={40} />
            </button>
          </div>

          <div className="menu-content">
            {/* Links principales solo en móvil */}
            <div className="mobile-main-links">
              {mainLinks.map((link) => (
                <>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      className="mobile-main-item"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {link.name}
                    </a>
                  ) : (
                    <NavLink
                      to={link.href}
                      className="mobile-main-item"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {link.name}
                    </NavLink>
                  )}
                </>
              ))}
            </div>

            {/* Secciones detalladas */}
            {menuSections.map((section) => (
              <div key={section.title} className="menu-section">
                <div className="section-header">
                  <span className="section-accent"></span>
                  {section.title}
                </div>
                <ul className="link-list">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      {link.external ? (
                        <a
                          href={link.href}
                          target="_blank"
                          className="section-link"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {link.name} <ExternalLink size={12} />
                        </a>
                      ) : (
                        <NavLink
                          to={link.href}
                          className="section-link"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {link.name} <ChevronRight size={12} />
                        </NavLink>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          {/* Accesos rápidos */}
          <div className="quick-links">
            {quickLinks.map((link) => (
              <>
                {link.external ? (
                  <a
                    href={link.href}
                    target="_blank"
                    className="quick-link-item"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.name} <ExternalLink size={12} />
                  </a>
                ) : (
                  <NavLink
                    to={link.href}
                    className="quick-link-item"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.name}<ChevronRight size={12} />
                  </NavLink>
                )}
              </>
            ))}
          </div>
        </aside>
      </header>
    </>
  );
};

export default function App() {
  return <Header />;
}
